<template>
  <main>
    <div class="page-area">
      <div class="breadcumb-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="breadcrumb text-center">
              <div class="section-headline white-headline">
                <h3>商务合作</h3>
              </div>
              <!-- <ul class="breadcrumb-bg">
                <li class="home-bread">商务合作</li>
                <li>联系我们</li>
              </ul>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about-area bg-color-2 area-padding u-coment">
      <ul class="container">
        <li class="cooperation">
          <p>
            中共中央政治局常务委员会2020年3月4日召开会议，研究当前疫情防控和稳定经济社会运行重点工作。会议强调，要加快新型基础设施建设进度。
          </p>
          <p>
            “新型基础设施建设”主要包括5G基建、大数据中心、工业互联网、特高压、城际高速铁路和城市轨道交通、新能源汽车及充电桩、人工智能七大领域
            其中5G建设直接放在了整个新基建列表的头名。有政策上的加持，未来我国5G网络建设将进一步加快，与“新型基础设施建设”相关的产业和行业将获得重大利好。
          </p>
          <p>
            未来随着国家5G网络体系建设的成熟，云电脑也将带动数以亿计的新消费群体。进入这一生态系统后，市场整体需求将会增加。
            基于现有商业模式、内容探索以及参与方式的挑战和创新出现，带来新的变革。海星云电脑在这一时代背景下应运而生，其运营公司为星灜科技（北京）有限公司。
          </p>
          <img draggable="false" src="@/assets/business.png" />
        </li>
      </ul>
    </div>
    <!-- End breadcumb Area -->
    <!-- Start contact Area -->
    <div class="contact-area bg-color-2 page-padding">
      <div class="container">
        <div class="row">
          <div class="contact-inner">
            <!-- Start contact icon column -->
            <!-- <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="contact-icon text-center">
                <div class="single-icon">
                  <i class="fa fa-mobile"></i>
                  <p>
                    <span>可然/Keran ：商务总监</span>
                    <br />
                    <span>邮箱：Keran@starvictory.com</span>
                    <br />
                    <span>手机/微信：13552315309</span>
                    <img
                      draggable="false"
                      src="../../static/images/shangwu/kr.jpg"
                      alt="海星云商务合作"
                    />
                  </p>
                </div>
              </div>
            </div> -->
            <!-- Start contact icon column -->
            <!-- <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="contact-icon text-center">
                <div class="single-icon">
                  <i class="fa fa-envelope-o"></i>
                  <p>
                    Email : cavalr32@gmail.com
                    <br />
                    <span>Web: www.rockstheme.com</span>
                  </p>
                </div>
              </div>
            </div>-->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="contact-icon text-center">
                <div class="single-icon">
                  <i class="fa fa-mobile"></i>
                  <p>
                    <span>武侠：商务总监</span>
                    <br />

                    <span>邮箱：wx@starvictory.com</span>
                    <br />
                    <span>手机/微信: 13801313925</span>
                    <img
                      draggable="false"
                      src="../../static/images/shangwu/sss.png"
                      alt="海星云商务合作"
                    />
                  </p>
                </div>
              </div>
            </div>
            <!-- Start contact icon column -->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="contact-icon text-center">
                <div class="single-icon">
                  <i class="fa fa-map-marker"></i>
                  <p>
                    公司地址 : 北京市海淀区
                    <br />
                    <span>中间建筑西杉创意园二区18号楼03</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End row -->
        <div class="row">
          <!-- Start contact icon column -->
          <div class="col-md-6 col-sm-6 col-xs-12">
            <!-- Start Map -->
            <div class="map-area">
              <div id="googleMap" style="width: 100%; height: 380px"></div>
            </div>
            <!-- End Map -->
          </div>
          <!-- End contact icon -->
          <!-- <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="contact-form">
              <div class="row">
                <form id="contactForm" method="POST" action="contact.php" class="contact-form">
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      type="text"
                      id="name"
                      class="form-control"
                      placeholder="Name"
                      required
                      data-error="Please enter your name"
                    />
                    <div class="help-block with-errors"></div>
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      type="email"
                      class="email form-control"
                      id="email"
                      placeholder="Email"
                      required
                      data-error="Please enter your email"
                    />
                    <div class="help-block with-errors"></div>
                  </div>
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <input
                      type="text"
                      id="msg_subject"
                      class="form-control"
                      placeholder="Subject"
                      required
                      data-error="Please enter your message subject"
                    />
                    <div class="help-block with-errors"></div>
                  </div>
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <textarea
                      id="message"
                      rows="7"
                      placeholder="Massage"
                      class="form-control"
                      required
                      data-error="Write your message"
                    ></textarea>
                    <div class="help-block with-errors"></div>
                  </div>
                  <div class="col-md-12 col-sm-12 col-xs-12 text-center">
                    <button type="submit" id="submit" class="add-btn contact-btn">Send message</button>
                    <div id="msgSubmit" class="h3 text-center hidden"></div>
                    <div class="clearfix"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>-->
          <!-- End contact Form -->
        </div>
        <!-- 全局qq和微信联系方式 index中有全局 -->
        <!-- <div class="hotline">
          <i class="fa fa-qq link"></i>
          <div class="qrcode-div">
            <img
              class="image"
              src="/static/images/icon/QQ_qrcode_20200618120255.jpg"
            />
          </div>
        </div>
        <div class="hotline2">
          <i class="fa fa-wechat link-wechat"></i>
          <div class="qrcode-div2">
            <img class="image" src="/static/images/icon/Wechat2.jpg" />
          </div>
        </div> -->
        <!-- built files will be auto injected -->
      </div>
    </div>
  </main>
</template>
<script>
export default {
  metaInfo: {
    title: '海星云-商务合作',
    meta: [
      {
        name: 'keywords',
        content: '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content: '海星云数据中心服务器采用的是i9 9900X+RTX2080ti的规格配置，用户无需下载更新即可畅玩海量大型游戏。 公司自主研发服务器并获得多项软著认证，如您有合作意向，海星云随时欢迎您的加入！'
      }
    ]
  },
  data () {
    return {}
  },
  methods: {},

  mounted () {}
}
</script>
<style lang="scss" scoped>
.cooperation {
  padding-top: 50px;
  p {
    text-indent: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue